import React, { useMemo } from 'react'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ScrollTable from 'components/global/CUK/ScrollTable'
import TableViewBase from 'packages/ui/Table/Table'
import { useTable } from 'packages/ui/Table'
import EmptyScreen from 'packages/ui/EmptyScreen'

import useSsid from './use-ssid'
import { useHasNotSiteSelected } from '../use-equipments'
import COLUMNS_CONFIG from './config-columns'

const Table = ({ equipments, sortApi, onRowClick }) => {
  const {t} = useTranslation()
  const { selection, shouldFetchNextPage, fetchNextPage } = useSsid({
    equipments,
    sortApi,
  })
  const columns = useMemo(() => {
    return COLUMNS_CONFIG
  }, [COLUMNS_CONFIG])
  const hasNoSiteSelected = useHasNotSiteSelected()
  const apiTable = useTable({
    items: selection ? sortApi.sort(selection) : [],
    columns,
    onRowClick: onRowClick,
    rowKey: 'ssid_name'
  })

  if (hasNoSiteSelected) {
    return <EmptyScreen icon="gauge-high">{t('supervision.no_site_selected')}</EmptyScreen>
  } else if (!selection.length) {
    return <EmptyScreen icon="gauge-high">{t('supervision.no_ssid')}</EmptyScreen>
  }
  return (
    <Stack
      sx={{
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1 1 auto',
        scrollbarWidth: 'none',
        height: '100%',
        '&::-webkit-scrollbar ': {
          display: 'none',
        },
      }}
    >
      <ScrollTable
        fetchNextPage={fetchNextPage}
        shouldFetchNextPage={shouldFetchNextPage}
        collapse={onRowClick ? true : false}
      >
        <TableViewBase
          apiTable={apiTable}
          sort={{
            by: sortApi.orderBy,
            direction: sortApi.orderDirection,
            onChange: (name) => {
              const column = columns.find((column) => column.name === name)

              sortApi.orderByChange(column.sortBy || column.name)
            },
          }}
        />
      </ScrollTable>
    </Stack>
  )
}

export default Table
